// Bilingual content for ESRA S.R.L.S.
export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
      quote: "Free quote",
    },
    common: {
      readMore: "Discover",
      brand: "ESRA",
      brandFull: "ESRA S.R.L.S.",
      based: "Turin, Italy — Est. 2021",
      year: "Est. MMXXI",
    },
    home: {
      eyebrow: "Plaster · Stucco · Decorative finishes",
      titleA: "Your walls,",
      titleB: "our passion.",
      lead: "Professional plastering & stucco for refined homes — crafted by hand in Turin since 2021.",
      ctaPrimary: "Request a free quote",
      ctaGhost: "See our craft",
      introTitle: "An atelier of finishes for residential interiors",
      introBody:
        "ESRA S.R.L.S. is a Turin-based atelier specialised in interior wall plastering, Venetian stucco and decorative finishes. We work exclusively with private homeowners and designers who care about the texture, light and quiet beauty of a finished wall.",
      servicesEyebrow: "What we do",
      servicesTitle: "Three crafts. One obsession with finish.",
      service1Title: "Plastering",
      service1Body: "Traditional and modern plaster on new or existing walls, perfectly smooth and ready for life.",
      service2Title: "Stucco & decorative",
      service2Body: "Stucco Veneziano, marmorino and patinas — surfaces that change with the light.",
      service3Title: "Wall restoration",
      service3Body: "Crack repair, surface levelling and full preparation for paint or wallpaper.",
      processEyebrow: "How we work",
      processTitle: "A calm, considered process — from first visit to last brush stroke.",
      step1: "On-site visit & free quote",
      step2: "Samples & material selection",
      step3: "Protected, clean job site",
      step4: "Hand-applied finishing",
      quote: "Quality and reliability are our trademarks.",
      quoteBy: "Noureddine Abdallah, founder",
      statsTitle: "A small team. A serious craft.",
      stat1: "Since 2021",
      stat1Label: "Founded in Turin",
      stat2: "4",
      stat2Label: "Skilled craftsmen",
      stat3: "100%",
      stat3Label: "Residential interiors",
      ctaTitle: "Let us finish your walls beautifully.",
      ctaBody: "Free on-site visit and quote across Turin and surroundings.",
    },
    services: {
      eyebrow: "Services",
      title: "Six finishes, applied with one standard.",
      lead: "We specialise in plastering and stucco for residential interiors. Every project is delivered on time, with respect for your home and a clean job site.",
      list: [
        {
          title: "Traditional plastering",
          body: "Base plaster and smoothing for new builds and renovations — the foundation of every refined wall.",
        },
        {
          title: "Stucco Veneziano & decorative stucco",
          body: "Marbled, polished and patinated finishes inspired by the Venetian tradition. Depth, warmth and a soft shimmer of light.",
        },
        {
          title: "Wall smoothing & levelling",
          body: "Filling, sanding and levelling of damaged or uneven surfaces — invisible work for a perfect canvas.",
        },
        {
          title: "Crack & damage repair",
          body: "Targeted repair of cracks, holes and water damage with materials matched to the existing wall.",
        },
        {
          title: "Preparation for paint or wallpaper",
          body: "Prime, fill and finish — surfaces handed over ready for paint, wallpaper or decorative work.",
        },
        {
          title: "Custom decorative finishes",
          body: "Bespoke effects, colours and textures developed with you and provided on quote.",
        },
      ],
      closeTitle: "Every wall is finished by experienced craftsmen.",
      closeBody: "All works are carried out on free quote, with transparent timing and pricing.",
    },
    about: {
      eyebrow: "About",
      title: "A Turin atelier with Mediterranean roots.",
      lead:
        "Founded in 2021 by Noureddine Abdallah, ESRA S.R.L.S. is a small Turin atelier focused exclusively on the interior finishes of private homes — plastering, stucco and decorative work.",
      historyTitle: "Our story",
      historyBody:
        "Although ESRA holds a broad construction licence, we deliberately chose to focus on one thing: the quality of an interior wall. Less variety, more mastery. We work with homeowners, architects and interior designers who care about how a surface feels, not only how it looks.",
      valuesTitle: "What we stand for",
      values: [
        { t: "Seriousness", b: "We arrive when we say we will and we finish what we start." },
        { t: "Cleanliness", b: "Floors covered, dust contained, your home protected from day one." },
        { t: "Punctuality", b: "Honest planning and transparent communication, start to finish." },
        { t: "Respect", b: "Your home is not a job site — it is a place we are invited into." },
      ],
      founderEyebrow: "The founder",
      founderTitle: "Noureddine Abdallah",
      founderBody:
        "Born in 1978 in Boumerdes (Tunisia), Noureddine has built his career around the trades of construction and craftsmanship. After years on Italian job sites, he founded ESRA in Turin in 2021 with one ambition: to bring the patience and finesse of artisan finishing to private homes. Tunisian-born and Italian-resident, he leads a team of four skilled craftsmen.",
      teamTitle: "A team of four craftsmen",
      teamBody:
        "ESRA is a deliberately small team. That is how we keep control of finish quality on every project, from a single hallway to a full apartment refurbishment.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let’s talk about your walls.",
      lead: "Send us a few details — we usually answer within one working day and a free on-site visit can be arranged in Turin and the surrounding area.",
      formTitle: "Request a free quote",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      message: "Tell us about your project",
      messagePlaceholder: "Type of wall, surface (sqm), desired finish, expected timing…",
      submit: "Send message",
      sending: "Sending…",
      successTitle: "Thank you — message received.",
      successBody: "We will be in touch shortly to arrange a free on-site visit.",
      errorTitle: "Something went wrong.",
      errorBody: "Please try again or write to us directly by email.",
      infoTitle: "Atelier",
      infoAddress: "Via Sigismondo Gerdil 5/B\n10152 Torino (TO) — Italy",
      infoPhone: "+39 366 2689583",
      infoEmail: "contact@esra_srls.com",
      infoPec: "12484970012@impresa.italia.it",
      hoursTitle: "By appointment",
      hoursBody: "Monday — Friday\nFree on-site visit on request",
      mapTitle: "Find us in Turin",
    },
    legal: {
      eyebrow: "Legal",
      title: "Legal mentions",
      lead: "In accordance with Italian law and the European GDPR.",
      sections: [
        {
          h: "Company",
          lines: [
            "Company name — ESRA S.R.L.S.",
            "Legal form — Società a Responsabilità Limitata Semplificata",
            "Share capital — € 500,00 fully paid up",
            "Registered office — Via Sigismondo Gerdil 5/B, 10152 Torino (TO), Italy",
            "REA — TO-1293356",
            "Fiscal code / P.IVA — 12484970012",
            "Date of constitution — 13/04/2021",
            "Start of activity — 17/06/2021",
          ],
        },
        {
          h: "Legal representative",
          lines: [
            "Noureddine Abdallah — sole shareholder and sole director.",
            "Fiscal code — BDLNDD78A20Z352X",
          ],
        },
        {
          h: "Contact",
          lines: [
            "Public email — contact@esra_srls.com",
            "Certified email (PEC) — 12484970012@impresa.italia.it",
            "Phone — +39 366 2689583",
          ],
        },
        {
          h: "Hosting",
          lines: [
            "This website is hosted by the provider chosen by ESRA S.R.L.S. The current hosting provider is indicated on request.",
          ],
        },
        {
          h: "Intellectual property",
          lines: [
            "All content (texts, images, layouts, graphical elements) is the property of ESRA S.R.L.S. or used with permission. Any reproduction without prior written consent is prohibited.",
          ],
        },
        {
          h: "Personal data — GDPR",
          lines: [
            "Data collected through the contact form (first name, last name, email, phone, message) is processed solely to reply to your request and is never shared with third parties for commercial purposes.",
            "In accordance with the EU Regulation 2016/679 (GDPR), you may request access, rectification or deletion of your data by writing to contact@esra_srls.com.",
          ],
        },
      ],
    },
    terms: {
      eyebrow: "Legal",
      title: "Terms & Conditions",
      lead: "By browsing this website you accept the conditions described below.",
      sections: [
        {
          h: "Purpose",
          lines: [
            "This website is published by ESRA S.R.L.S. and aims at presenting the company, its services and its contact details. It is informational and does not constitute a contractual offer.",
          ],
        },
        {
          h: "Use of the website",
          lines: [
            "The user undertakes to use this website in accordance with applicable laws and not to disturb its proper functioning. ESRA S.R.L.S. may suspend or modify the site at any time without notice.",
          ],
        },
        {
          h: "Liability",
          lines: [
            "Information published on this site is provided for indicative purposes. ESRA S.R.L.S. takes care to publish accurate information but cannot be held responsible for any error, omission or unavailability of the site.",
          ],
        },
        {
          h: "Hypertext links",
          lines: [
            "This website may contain links to external websites. ESRA S.R.L.S. has no control over their content and cannot be held responsible for it.",
          ],
        },
        {
          h: "Intellectual property",
          lines: [
            "All elements composing this website are protected by intellectual property law. Any reproduction, partial or total, is forbidden without prior written authorisation.",
          ],
        },
        {
          h: "Applicable law",
          lines: [
            "These terms are governed by Italian law. Any dispute relating to the website will be brought before the competent courts of Turin.",
          ],
        },
      ],
    },
    footer: {
      tagline: "Plaster · Stucco · Decorative finishes",
      address: "Via Sigismondo Gerdil 5/B\n10152 Torino (TO), Italy",
      rights: "All rights reserved.",
      legal: "Legal mentions",
      terms: "Terms & Conditions",
      navTitle: "Navigate",
      contactTitle: "Contact",
      followTitle: "Atelier",
    },
  },
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      about: "Chi siamo",
      contact: "Contatti",
      quote: "Preventivo",
    },
    common: {
      readMore: "Scopri",
      brand: "ESRA",
      brandFull: "ESRA S.R.L.S.",
      based: "Torino, Italia — dal 2021",
      year: "Anno MMXXI",
    },
    home: {
      eyebrow: "Intonaci · Stucchi · Finiture decorative",
      titleA: "Le vostre pareti,",
      titleB: "la nostra passione.",
      lead:
        "Intonacatura e stuccatura professionale per case raffinate — realizzate a mano a Torino dal 2021.",
      ctaPrimary: "Richiedi un preventivo gratuito",
      ctaGhost: "Scopri il nostro lavoro",
      introTitle: "Un atelier di finiture per interni residenziali",
      introBody:
        "ESRA S.R.L.S. è un atelier torinese specializzato in intonacatura di interni, stucco veneziano e finiture decorative. Lavoriamo esclusivamente con privati e progettisti che amano la texture, la luce e la silenziosa bellezza di una parete ben finita.",
      servicesEyebrow: "Cosa facciamo",
      servicesTitle: "Tre mestieri. Un’ossessione per la finitura.",
      service1Title: "Intonacatura",
      service1Body: "Intonaci tradizionali e moderni su pareti nuove o esistenti, perfettamente lisci e pronti all’uso.",
      service2Title: "Stucco & decorativo",
      service2Body: "Stucco Veneziano, marmorino e patine — superfici che cambiano con la luce.",
      service3Title: "Restauro di pareti",
      service3Body: "Riparazione fessure, livellamento e preparazione completa per pittura o carta da parati.",
      processEyebrow: "Come lavoriamo",
      processTitle: "Un processo calmo e meditato — dal primo sopralluogo all’ultima pennellata.",
      step1: "Sopralluogo e preventivo gratuito",
      step2: "Campioni e scelta dei materiali",
      step3: "Cantiere protetto e pulito",
      step4: "Finitura applicata a mano",
      quote: "Qualità e affidabilità sono i nostri marchi di fabbrica.",
      quoteBy: "Noureddine Abdallah, fondatore",
      statsTitle: "Una piccola squadra. Un mestiere serio.",
      stat1: "Dal 2021",
      stat1Label: "Fondata a Torino",
      stat2: "4",
      stat2Label: "Artigiani qualificati",
      stat3: "100%",
      stat3Label: "Interni residenziali",
      ctaTitle: "Lasciate finire splendidamente le vostre pareti.",
      ctaBody: "Sopralluogo e preventivo gratuiti a Torino e dintorni.",
    },
    services: {
      eyebrow: "Servizi",
      title: "Sei finiture, applicate con un solo standard.",
      lead:
        "Siamo specializzati nell’intonacatura e nella stuccatura per interni residenziali. Ogni cantiere viene realizzato nei tempi previsti, con rispetto della vostra casa e cantieri puliti.",
      list: [
        { title: "Intonacatura tradizionale", body: "Intonaco di fondo e lisciatura per nuove costruzioni e ristrutturazioni — la base di ogni parete raffinata." },
        { title: "Stucco Veneziano & decorativo", body: "Finiture marmorate, lucidate e patinate ispirate alla tradizione veneziana. Profondità, calore e una luce morbida." },
        { title: "Lisciatura e livellamento", body: "Rasatura, carteggiatura e livellamento di superfici danneggiate o irregolari — lavoro invisibile per una tela perfetta." },
        { title: "Riparazione di crepe e danni", body: "Riparazione mirata di crepe, fori e danni da umidità con materiali coerenti con la parete esistente." },
        { title: "Preparazione per pittura o carta da parati", body: "Fondi, rasature e finitura — superfici consegnate pronte per pittura, carta o decoro." },
        { title: "Finiture decorative su misura", body: "Effetti, colori e texture personalizzati, sviluppati con voi e forniti su preventivo." },
      ],
      closeTitle: "Ogni parete è rifinita da artigiani esperti.",
      closeBody: "Tutti i lavori vengono eseguiti su preventivo gratuito, con tempi e costi trasparenti.",
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Un atelier torinese di radici mediterranee.",
      lead:
        "Fondata nel 2021 da Noureddine Abdallah, ESRA S.R.L.S. è un piccolo atelier torinese dedicato esclusivamente alle finiture interne delle case private — intonaci, stucchi e decorazioni.",
      historyTitle: "La nostra storia",
      historyBody:
        "Anche se ESRA possiede una licenza edilizia ampia, abbiamo scelto deliberatamente di concentrarci su una sola cosa: la qualità di una parete interna. Meno varietà, più maestria. Lavoriamo con privati, architetti e interior designer attenti non solo all’estetica, ma alla sensazione di una superficie.",
      valuesTitle: "I nostri valori",
      values: [
        { t: "Serietà", b: "Arriviamo quando lo diciamo e finiamo ciò che iniziamo." },
        { t: "Pulizia", b: "Pavimenti coperti, polvere contenuta, casa protetta dal primo giorno." },
        { t: "Puntualità", b: "Pianificazione onesta e comunicazione trasparente, dall’inizio alla fine." },
        { t: "Rispetto", b: "La vostra casa non è un cantiere — è un luogo in cui siamo invitati." },
      ],
      founderEyebrow: "Il fondatore",
      founderTitle: "Noureddine Abdallah",
      founderBody:
        "Nato nel 1978 a Boumerdes (Tunisia), Noureddine ha costruito la sua carriera nei mestieri dell’edilizia e dell’artigianato. Dopo anni di cantieri italiani, ha fondato ESRA a Torino nel 2021 con un’ambizione: portare la pazienza e la finezza della finitura artigianale nelle case private. Di origine tunisina e residente in Italia, guida una squadra di quattro artigiani qualificati.",
      teamTitle: "Una squadra di quattro artigiani",
      teamBody:
        "ESRA è volutamente una piccola squadra. È così che manteniamo il controllo della qualità della finitura in ogni cantiere, da un singolo corridoio a un appartamento intero.",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Parliamo delle vostre pareti.",
      lead:
        "Inviateci qualche dettaglio — di solito rispondiamo entro un giorno lavorativo e fissiamo un sopralluogo gratuito a Torino e dintorni.",
      formTitle: "Richiedi un preventivo gratuito",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Email",
      phone: "Telefono",
      message: "Descrivete il vostro progetto",
      messagePlaceholder: "Tipo di parete, superficie (mq), finitura desiderata, tempistiche…",
      submit: "Invia messaggio",
      sending: "Invio…",
      successTitle: "Grazie — messaggio ricevuto.",
      successBody: "Vi contatteremo a breve per fissare un sopralluogo gratuito.",
      errorTitle: "Qualcosa è andato storto.",
      errorBody: "Riprovate o scriveteci direttamente via email.",
      infoTitle: "Atelier",
      infoAddress: "Via Sigismondo Gerdil 5/B\n10152 Torino (TO) — Italia",
      infoPhone: "+39 366 2689583",
      infoEmail: "contact@esra_srls.com",
      infoPec: "12484970012@impresa.italia.it",
      hoursTitle: "Su appuntamento",
      hoursBody: "Lunedì — Venerdì\nSopralluogo gratuito su richiesta",
      mapTitle: "Trovaci a Torino",
    },
    legal: {
      eyebrow: "Note legali",
      title: "Note legali",
      lead: "In conformità con la legge italiana e con il GDPR europeo.",
      sections: [
        {
          h: "Società",
          lines: [
            "Ragione sociale — ESRA S.R.L.S.",
            "Forma giuridica — Società a Responsabilità Limitata Semplificata",
            "Capitale sociale — € 500,00 interamente versato",
            "Sede legale — Via Sigismondo Gerdil 5/B, 10152 Torino (TO), Italia",
            "REA — TO-1293356",
            "Codice fiscale / P.IVA — 12484970012",
            "Data di costituzione — 13/04/2021",
            "Inizio attività — 17/06/2021",
          ],
        },
        {
          h: "Rappresentante legale",
          lines: [
            "Noureddine Abdallah — socio unico e amministratore unico.",
            "Codice fiscale — BDLNDD78A20Z352X",
          ],
        },
        {
          h: "Contatti",
          lines: [
            "Email pubblica — contact@esra_srls.com",
            "PEC — 12484970012@impresa.italia.it",
            "Telefono — +39 366 2689583",
          ],
        },
        {
          h: "Hosting",
          lines: [
            "Il sito è ospitato dal fornitore scelto da ESRA S.R.L.S. Il provider attuale è indicato su richiesta.",
          ],
        },
        {
          h: "Proprietà intellettuale",
          lines: [
            "Tutti i contenuti (testi, immagini, layout, elementi grafici) sono proprietà di ESRA S.R.L.S. o utilizzati con autorizzazione. Ogni riproduzione senza preventivo consenso scritto è vietata.",
          ],
        },
        {
          h: "Dati personali — GDPR",
          lines: [
            "I dati raccolti tramite il modulo di contatto (nome, cognome, email, telefono, messaggio) sono trattati al solo scopo di rispondere alla vostra richiesta e non sono mai condivisi con terzi a fini commerciali.",
            "Ai sensi del Regolamento UE 2016/679 (GDPR), potete richiedere accesso, rettifica o cancellazione dei vostri dati scrivendo a contact@esra_srls.com.",
          ],
        },
      ],
    },
    terms: {
      eyebrow: "Note legali",
      title: "Termini e Condizioni",
      lead: "Navigando su questo sito accettate le condizioni descritte qui di seguito.",
      sections: [
        { h: "Oggetto", lines: ["Il sito è pubblicato da ESRA S.R.L.S. con lo scopo di presentare l’azienda, i suoi servizi e i contatti. È a carattere informativo e non costituisce un’offerta contrattuale."] },
        { h: "Uso del sito", lines: ["L’utente si impegna a utilizzare il sito nel rispetto delle leggi applicabili e a non perturbarne il funzionamento. ESRA S.R.L.S. può sospendere o modificare il sito in qualsiasi momento senza preavviso."] },
        { h: "Responsabilità", lines: ["Le informazioni pubblicate hanno valore indicativo. ESRA S.R.L.S. cura la pubblicazione di contenuti accurati ma non può essere ritenuta responsabile di errori, omissioni o indisponibilità del sito."] },
        { h: "Link ipertestuali", lines: ["Il sito può contenere link verso siti esterni. ESRA S.R.L.S. non controlla i loro contenuti e non può esserne ritenuta responsabile."] },
        { h: "Proprietà intellettuale", lines: ["Tutti gli elementi che compongono il sito sono protetti dal diritto della proprietà intellettuale. Ogni riproduzione, totale o parziale, è vietata senza preventiva autorizzazione scritta."] },
        { h: "Legge applicabile", lines: ["Le presenti condizioni sono regolate dalla legge italiana. Ogni controversia relativa al sito sarà sottoposta ai tribunali competenti di Torino."] },
      ],
    },
    footer: {
      tagline: "Intonaci · Stucchi · Finiture decorative",
      address: "Via Sigismondo Gerdil 5/B\n10152 Torino (TO), Italia",
      rights: "Tutti i diritti riservati.",
      legal: "Note legali",
      terms: "Termini e Condizioni",
      navTitle: "Naviga",
      contactTitle: "Contatti",
      followTitle: "Atelier",
    },
  },
};

export const defaultLocale = "en";
